import { FC } from 'react'

import LeftRobotCard from './common/LeftRobotCard'
import Button from 'components/forms/Button'
import useWindowSize from 'components/util/useWindowSize'

type Props = {}

const WhoAreWeCard: FC<Props> = () => {
  const size = useWindowSize()
  return (
    <LeftRobotCard
      image={{
        alt: 'Robot upper half with envelopes',
        desktop: {
          dimensions: {
            height: 584,
            width: 518,
          },
          src: '/images/new/robot-upperhalf-cut-aus.png',
        },
        mobile: {
          dimensions: {
            height: 846,
            width: 552,
          },
          src: '/images/new/robot-upperhalf-aus.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '50%' : '100%'}
      reverseColumnOrder={!size.isLgOrHigher}
      imageStyle={{
        maxWidth: '100%',
        objectFit: 'cover',
      }}
    >
      <div
        className='d-flex flex-1 flex-column gap-2 gap-lg-4 px-4 pt-8 pe-lg-8 pt-lg-30 pb-lg-51'
        style={{
          marginLeft: size.isLgOrHigher ? '-8%' : '0',
        }}
      >
        <h2 className='fw-semibold fs-fluid-36-80 lh-105 mb-0'>Who we are</h2>
        <span className='fw-semibold lh-119 fs-fluid-18-28'>
          Established in the Hoxton area of central London in 2010, The Hoxton
          Mix is not your typical virtual office SaaS provider. With a passion
          for innovation and a drive to empower SMEs worldwide, we have become a
          leading name in the industry. We operate in central London, and Sydney,
          Australia.
        </span>
      </div>
    </LeftRobotCard>
  )
}

export default WhoAreWeCard
